"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankEnum = void 0;
var BankEnum;
(function (BankEnum) {
    BankEnum[BankEnum["PAYNETICS"] = 0] = "PAYNETICS";
    BankEnum[BankEnum["WEAVR"] = 1] = "WEAVR";
})(BankEnum || (exports.BankEnum = BankEnum = {}));
